import React, {useState} from "react";
import S from './EventSubscription.module.scss';
import {Checkbox, TextInput} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import {useForm} from "@mantine/form";
import {notifications} from "@mantine/notifications";


interface FormValues {
    email: string;
    check: boolean;
}

export const EventSubscription = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validateForm = (values: FormValues) => {
        const errors: Partial<Record<keyof FormValues, string>> = {};
        if (!values.email) {
            errors.email = 'Обязательное поле';
        } else if (!emailRegex.test(values.email)) {
            errors.email = 'Некорректный email';
        }
        if (!values.check) errors.check = 'Необходимо согласие на обработку данных';

        return errors;
    };

    const subscriptionForm = useForm<FormValues>({
        initialValues: {
            email: '',
            check: false,
        },
        validate: (values) => validateForm(values),
    });

    const sendRequest = async (values: FormValues) => {
        const formData = new FormData();
        formData.append('email', values.email);

        const response = await fetch('/api/v1/subscribe', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Ошибка ${response.status}: ${errorText || response.statusText}`);
        }

        return {success: true};
    };

    const subscriptionSubmit = async (values: FormValues) => {
        setIsLoading(true);

        try {
            await sendRequest(values);
            notifications.show({
                color: 'green',
                autoClose: 5000,
                title: 'Заявка успешно отправлена!',
                message: 'Скоро с вами свяжутся для уточнения деталей',
            });
            subscriptionForm.reset();
        } catch (error) {
            notifications.show({
                color: 'red',
                autoClose: 5000,
                title: 'Ошибка при отправке',
                message: 'Пожалуйста, попробуйте позже или свяжитесь с нами по телефону',
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={S.subscriptionContainer}>
            <div className={S.title}>Будьте в курсе событий</div>
            <div className={S.text}>
                Подпишитесь на анонсы новых мероприятий EVOFORUM — только деловые события, без спама.
            </div>
            <form onSubmit={subscriptionForm.onSubmit(subscriptionSubmit)}>
                <div className={S.boxForm}>
                    <TextInput
                        placeholder="Укажите, пожалуйста, вашу электронную почту *"
                        withAsterisk
                        size="lg"
                        className={S.textInput}
                        key={subscriptionForm.key('email')}
                        {...subscriptionForm.getInputProps('email')}
                    />
                    <button
                        className={S.button}
                        type="submit"
                    >
                        {isLoading ? 'Отправка...' : 'ПОДПИСАТЬСЯ'}
                    </button>
                </div>
                <Checkbox
                    label={
                        <div className={S.labelCheckbox}>Я даю своё согласие на обработку <span><u
                            onClick={(e) => {
                                e.stopPropagation();
                                navigate('/privacy-policy');
                            }}>персональных данных</u>
                                </span>
                        </div>
                    }
                    key={subscriptionForm.key('check')}
                    {...subscriptionForm.getInputProps('check', {type: 'checkbox'})}
                    color="#0C31C8FF"
                />
            </form>
        </div>
    );
};